import { SCHEMA } from '@vedalib/editor/lib/brand'
import { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { Typography } from 'components/uiKit/Typography'
import { BrandButtonFont, BrandFormFontBase, BrandGoBack } from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useElementFontCss, useElementFontValues, useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { ChartBrandForms, ChartFormBrandType } from './chartTypes'

export const FONT_FORM_SCHEMA = genSchema(SCHEMA.chart.font, {
  base: FONT_FIELDS.base,
  caption: FONT_FIELDS.caption,
})

const TypographyBase: ChartFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.base}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.chart.tags.fontMain')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const TypographyCaption: ChartFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.caption}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.chart.tags.fontDescription')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const ChartTypography: ChartFormBrandType = ({ device, edited, setForm, element }) => {
  const values = useElementFontValues('chart', device, element?.font)
  const styles = useElementFontCss('chart', device, element?.font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <Padding bottom gap sides>
      <BrandGoBack onClick={goBack}>
        <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
      </BrandGoBack>
      <BrandButtonFont
        edited={edited.font?.base}
        font='base'
        onClick={setForm}
        styles={styles.base}
        values={values.base}
      >
        {t('elements.chart.tags.fontMain')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited.font?.caption}
        font='caption'
        onClick={setForm}
        styles={styles.caption}
        values={values.caption}
      >
        {t('elements.chart.tags.fontDescription')}
      </BrandButtonFont>
    </Padding>
  )
}

const FONTS_FORM_MAP: ChartBrandForms = {
  [BrandFormEnum.TYPOGRAPHY]: ChartTypography,
  base: TypographyBase,
  caption: TypographyCaption,
}

export default FONTS_FORM_MAP
